import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { PureComponentWithInjectedProps } from 'utils/injectedProps';
import styles from './Carousel.module.scss';

type CarouselProps = {
  children: Array<*>,
};

@observer
export class Carousel extends PureComponentWithInjectedProps<CarouselProps, {}> {
  @observable styles = {
    width: 'auto',
    transform: '',
  };
  index = 0;
  carouselContainer = {};
  carouselWrapper = {};
  carouselItem = {};

  constructor(props) {
    super(props);
    this.carouselContainer = React.createRef();
    this.carouselWrapper = React.createRef();
    this.carouselItem = React.createRef();
  }

  componentDidMount() {
    if (this.props.children.length > 1) {
      const { width } = this.carouselContainer.current.getBoundingClientRect();
      this.styles.width = `${this.props.children.length * (width - 22)}px`;
    }
  }

  changeItem(index) {
    const { width } = this.carouselItem.current.getBoundingClientRect();
    this.index = index;
    this.styles.transform = `translate3d(-${width * index}px, 0, 0)`;
  }

  render() {
    const { children } = this.props;
    const {
      styles: { width, transform },
      carouselContainer,
      carouselWrapper,
      carouselItem,
    } = this;
    const isOnlyOne = children.length === 1;

    return (
      <div ref={carouselContainer} className={styles['carousel']}>
        <div
          ref={carouselWrapper}
          style={{ width, transform }}
          className={styles['carousel-wrapper']}
        >
          {children.map(el => {
            return (
              <div
                ref={carouselItem}
                className={`${styles['carousel-item']} ${
                  isOnlyOne ? styles['carousel-item-single'] : ''
                }`}
              >
                {el}
              </div>
            );
          })}
        </div>
        <div className={styles['carousel-thumbs']}>
          {children.length > 1 &&
            children.map((item, index) => {
              const active = index === this.index ? styles['active'] : '';
              return (
                <div
                  className={`${styles['carousel-thumb']} ${active}`}
                  onClick={() => this.changeItem(index)}
                />
              );
            })}
        </div>
      </div>
    );
  }
}
